import { useInfiniteQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { accreditationsService } from 'ogp/services';
import {
  CertificateTableRow,
  GetEmployeeCertificatesResponse,
} from '../employee-certificates-tab.types';

export const useGetEmployeeCertificates = (flexWorkerId: string) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.employeeCertificates(flexWorkerId),
    queryFn: async ({ pageParam = 0 }): Promise<GetEmployeeCertificatesResponse> => {
      const response = await accreditationsService.getEmployeeCertificates(
        flexWorkerId,
        pageParam,
        30
      );

      const mappedItems: CertificateTableRow[] = response.items.map((item) => ({
        certificateName: item.certificateName,
        download: '',
        startDate: item.startDate,
        endDate: item.expirationDate,
        trust: item.isTrusted,
        actions: '',
        certificateId: item.certificateId,
        accreditationId: item.accreditationId,
        flexWorkerId,
      }));

      return {
        items: mappedItems,
        totalRows: response.totalRows,
        nextPage: response.nextPage,
        hasNextPage: response.hasNextPage,
        hasPreviousPage: response.hasPreviousPage,
      };
    },
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
    keepPreviousData: true,
  });
};
